(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/modals/_onboarding_start_over_modal.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"comet-modal-overlay js-comet-modal-overlay comet-modal-overlay--backdrop\" role=\"dialog\"></div>\n<div class=\"comet-modal js-comet-modal\" role=\"document\" tabindex=\"0\">\n    <div id=onboarding-start-over-modal class=\"comet-modal__inner\">\n        <div class=\"comet-modal__header\">\n            <h3 class=\"comet-modal__header-content\">Start Over?</h3>\n        </div>\n        <div class=\"comet-modal__content\">\n            <p>Are you sure you want to start over? All progress will be lost.</p>\n        </div>\n        <div class=\"comet-modal__footer\">\n            <form method=\"post\" action=\"/onboarding/start-over\">\n                <input type=\"hidden\" name=\"token\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "token"), env.opts.autoescape);
output += "\">\n                <div class=\"comet-modal__button-row\">\n                    <button type=\"button\" class=\"comet-button comet-button--ghost comet-modal__button comet-modal__button--cancel js-comet-modal__close-button\">Cancel</button>\n                    <button type=\"submit\" class=\"comet-button comet-button--danger comet-modal__button\">Start Over</button>\n                </div>\n            </form>   \n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/modals/_onboarding_start_over_modal", function(){});

